/*
 * @Description: 
 * @Author: ke wen
 * @Date: 2021-02-23 17:33:04
 * @LastEditTime: 2021-03-10 14:49:36
 * @LastEditors: LastEditors
 * @Reference: 
 */
import { JSEncrypt } from "encryptlong"
export function createClientKey() {
    return new Promise((resolve, reject) => {
        var crypt = new JSEncrypt({
            default_key_size: 2048,
        });
        crypt.getKey();
        var publicKey = crypt.getPublicKey();
        var privateKey = crypt.getPrivateKey();

        // 去除-----*** RSA **** KEY----- 和空格换行
        publicKey = (publicKey.split('-----'))[2];
        publicKey = publicKey.replace(/\n/g, "").replace(/\r/g, "").replace(/\t/g, "").replace(/\s*/g, "");
        privateKey = (privateKey.split('-----'))[2];
        privateKey = privateKey.replace(/\n/g, "").replace(/\r/g, "").replace(/\t/g, "").replace(/\s*/g, "");

        // 返回生成的秘钥对
        let keyList = {
            private: privateKey,
            public: publicKey,
        }
        resolve(keyList)
    })
}
